document.addEventListener('DOMContentLoaded', () => {
    const $urgentbarEl = document.getElementById('urgentbar');

    if (!$urgentbarEl) return;

    const $urgentbarButton = $urgentbarEl.querySelector('.urgentbar-button');
    const isClosed = localStorage.getItem('asser-urgentbar');

    if ($urgentbarButton && !isClosed) {
        document.documentElement.classList.add('has-urgentbar');

        $urgentbarButton.addEventListener('click', (event) => {
            document.documentElement.classList.remove('has-urgentbar');
            localStorage.setItem('asser-urgentbar', true);
        });
    }
});
